import React from 'react';
import {styled} from 'styled-components';
import {Logo} from '../logo';
import {StyledProps, mediaQueries} from '../../modules/common';
import {ChangeLanguageLinkNavBar} from '../change-language-link';

const NavBarContentContainer = styled.div`
    border: none;
    padding: 0;

    display: flex;
    justify-content: space-between;
    align-items: center;

    width: 100%;
`;

interface Props {
    longShadow: boolean;
    currentPath: string;
}

interface BaseNavBarProps extends StyledProps, Props {}

const StyledChangeLanguageLink = styled(ChangeLanguageLinkNavBar)`
    padding: 8px 16px;
`;

const StyledLogo = styled(Logo)`
    padding: ${({theme}): string => theme.logo.padding};

    ${mediaQueries.lessThan('small')`
        padding: 8px 0;
        margin: 0;
    `};
`;

/**
 * Base component the static navbar
 */
const BaseNavBar = (props: BaseNavBarProps): JSX.Element => {
    const {className, currentPath} = props;
    const FonomaLogo = <StyledLogo target="_self" />;

    return (
        <div className={className}>
            <NavBarContentContainer>
                {FonomaLogo}
                <StyledChangeLanguageLink currentPath={currentPath} />
            </NavBarContentContainer>
        </div>
    );
};

/**
 * Static navbar component. Just renders the fixed block with the logo
 */
export const StaticNavBar = styled(BaseNavBar)<Props>`
    display: flex;
    background-color: ${(props): string => props.theme.navBar.backgroundColor};
    position: fixed;
    right: 0;
    left: 0;
    top: 0;
    z-index: 1030;
    min-height: ${(props): string =>
        `${props.theme.desktopMeasures.navBarHeight}${props.theme.unitsOfMeasure.px}`};

    ${mediaQueries.lessThan('small')`
        min-height: ${(props): string =>
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-unsafe-member-access
            `${props.theme.mobileMeasures.navBarHeight}${props.theme.unitsOfMeasure.px}`};
  `};
`;
